import React, {useState} from 'react'
import {Link} from 'react-router-dom'

function Contact() {
    const initialFormData = {
        name: '',
        email: '',
        phone: '',
        subject: '',
        msg: '',
      };
    
      const [formData, setFormData] = useState(initialFormData);
      const [submitStatus, setSubmitStatus] = useState(null);
    
      const handleSubmit = async (e) => {
        e.preventDefault();
    
        // Check if any of the form fields are empty
        if (
          formData.name.trim() === '' ||
          formData.email.trim() === '' ||
          formData.subject.trim() === '' ||
          formData.phone.trim() === '' ||
          formData.msg.trim() === ''
        ) {
          // If any field is empty, display an error message and return
          setSubmitStatus('error');
          return;
        }
    
        try {
          // Your fetch request to send the email
          // Assuming it is successful for demonstration purposes
          setSubmitStatus('success');
          setFormData(initialFormData); // Reset form data to initial empty values
        } catch (error) {
          console.error('Error:', error);
          setSubmitStatus('error');
        }
      };
    
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      };
  return (
    <div>
    <div className="section-bg section-padding subheader" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/subheader.jpg)' }}>
        <div className="container">
            <div className="row">
                <div className="col-12 text-center">
                    <h1 className="text-white page-title">Contact Us</h1>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- Subheader End -->
    <!-- Contact Map Start --> */}
    <section className="section-padding">
        <div className="container">
            <div className="row align-items-center justify-content-between">
                <div className="col-lg-6">
                    <div className="contact_map">
                    <iframe
                        title="Statue of Unity Map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3703.5056482171144!2d73.71688411431217!3d21.838023365035575!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39601d55e43af21f%3A0xb8e23c01a1f6eb18!2sStatue%20of%20Unity!5e0!3m2!1sen!2sin!4v1639550284244!5m2!1sen!2sin"
                        className="border-0 w-100 relative map"
                        id="map"
                        style={{ width: '100%', height: '500px', border: '0' }}
                        allowFullScreen=""
                        loading="lazy"
                    ></iframe>
                    </div>
                </div>
                <div className="col-lg-5">
                    <div className="section-header text-start">
                        <h3 className="title">Contact <span> Us</span></h3>
                        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore </p>
                    </div>
                    <div className="footer contact_map_info">
                        <ul className="ft_contact ft_menu">
                            <li>
                                <Link to="#">
                                    <i className="fas fa-phone-volume"></i>
                                    (+347) 123 456 7890
                                </Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <i className="fas fa-envelope"></i>
                                    example@example.com
                                </Link>
                            </li>
                           
                            <li>
                                <Link to="#">
                                    <i className="fas fa-map-marker-alt"></i>
                                    Street, 3821 Ben Street. NY 14424
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- Contact Map End -->
    <!-- Contact Form Start --> */}
    <section className="section pt-0">
        <div className="container">
            <div className="section-header text-start">
                <h3 className="title">Get In <span> Touch</span></h3>
                <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore </p>
            </div>
            {submitStatus === 'success' && (
            <div className='success-message mb-3'>
                Mail has been sent successfully!
            </div>
            )}
            <form onSubmit={handleSubmit} className="row form_style style_two">
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <input type="text" name="name" value={formData.name} onChange={handleChange} className="form-control form-control-custom" placeholder="Full Name" autoComplete="off" required=""/>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <input type="email" name="email" value={formData.email} onChange={handleChange} className="form-control form-control-custom" placeholder="Email I'd" autoComplete="off" required=""/>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <input type="text" name="phone" value={formData.phone} onChange={handleChange} className="form-control form-control-custom" placeholder="Phone No." autoComplete="off" required=""/>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <input type="text" name="subject" value={formData.subject} onChange={handleChange} className="form-control form-control-custom" placeholder="Subject" autoComplete="off" required=""/>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="form-group">
                            <textarea rows="8" name="msg" value={formData.msg} onChange={handleChange} className="form-control form-control-custom" placeholder="Message" autoComplete="off" required=""></textarea>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <button type="submit" className="thm-btn w-100" onClick={handleSubmit}>Submit</button>
                    </div>
                </div>
            </form>
        </div>
    </section>
    </div>
  )
}

export default Contact